import type {AdCategory} from '@frontend/modules/public/ads/AdsModuleTypes'
import {CategorySelectorDropdownMenuItem} from '@frontend/modules/public/ads/components/search/CategorySelectorDropdownMenuItem'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'

interface CategorySelectorDropdownMenuItemsProps {
    categories: AdCategory[]
    isSubcategory?: boolean
    onCategoryChange: (newCategory: AdCategory | null) => void
    expandedCategoryIds?: number[]
    onCategoryToggle?: (category: AdCategory) => void
}

// Список категорий (рекурсивный).
export function CategorySelectorDropdownMenuItems(props: CategorySelectorDropdownMenuItemsProps) {

    const {
        categories,
        expandedCategoryIds,
        isSubcategory,
        ...itemProps
    } = props

    return (
        <>
            {categories.map(category => (
                <>
                    <CategorySelectorDropdownMenuItem
                        key={String(category.id)}
                        {...itemProps}
                        category={category}
                        className={isSubcategory ? 'ps-7' : ''}
                    />
                    {!isSubcategory && category.children?.length > 0 && (
                        <Collapse
                            key={'subcategories-' + String(category.id)}
                            show={expandedCategoryIds?.includes(category.id) ?? false}
                            showImmediately
                        >
                            <CategorySelectorDropdownMenuItems
                                categories={category.children}
                                isSubcategory
                                onCategoryChange={itemProps.onCategoryChange}
                            />
                        </Collapse>
                    )}
                </>
            ))}
        </>
    )
}
